"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IWebflowBenefitMinimumSubscription = exports.IWebflowBenefitCategory = void 0;
var IWebflowBenefitCategory;
(function (IWebflowBenefitCategory) {
    IWebflowBenefitCategory["Health"] = "Health";
    IWebflowBenefitCategory["Legal"] = "Legal";
    IWebflowBenefitCategory["Wellness"] = "Wellness";
    IWebflowBenefitCategory["Finances"] = "Finances";
    IWebflowBenefitCategory["Other"] = "Other";
    IWebflowBenefitCategory["Insurance"] = "Insurance";
})(IWebflowBenefitCategory = exports.IWebflowBenefitCategory || (exports.IWebflowBenefitCategory = {}));
var IWebflowBenefitMinimumSubscription;
(function (IWebflowBenefitMinimumSubscription) {
    IWebflowBenefitMinimumSubscription["None"] = "None";
    IWebflowBenefitMinimumSubscription["Benefits"] = "Benefits";
    IWebflowBenefitMinimumSubscription["Essentials"] = "Essentials";
    IWebflowBenefitMinimumSubscription["Professional"] = "Professional";
    IWebflowBenefitMinimumSubscription["Corporate"] = "Corporate";
})(IWebflowBenefitMinimumSubscription = exports.IWebflowBenefitMinimumSubscription || (exports.IWebflowBenefitMinimumSubscription = {}));
//# sourceMappingURL=benefits.js.map